'use client'
import {
  useConfig_default
} from "./chunk-7WWZDHPB.mjs";
import {
  ContentfulMedia_default
} from "./chunk-XIZE6A22.mjs";
import {
  SYMBOLS
} from "./chunk-A4XRECLB.mjs";
import {
  useFavorites
} from "./chunk-BB4H5TUC.mjs";
import {
  useGetWeatherCondition
} from "./chunk-F7HCPT4F.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/weather/Weather.tsx
import { useState } from "react";
import { Link, useRouter, useTranslation } from "@wbk/config";
import { Button as Button2, Divider, Typography as Typography2 } from "@wbk/ui";
import { twMerge } from "tailwind-merge";

// src/components/weather/Info.tsx
import { ArrowIcon } from "@wbk/svg";
import { Button, ImageWithFallback, Typography } from "@wbk/ui";
import { jsx, jsxs } from "react/jsx-runtime";
var WeatherInfo = ({ data, unit, setUnit, color }) => {
  if (!data) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", { className: "flex justify-between", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-start gap-1", children: [
      /* @__PURE__ */ jsxs(Typography, { variant: "heading-XL", color: color || "secondary", children: [
        data.TemperatureSummary.Past6HourRange.Maximum[unit].Value,
        " ",
        SYMBOLS[unit]
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "grow", children: [
        /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1", children: [
          /* @__PURE__ */ jsx("div", { className: "flex items-center gap-px", children: /* @__PURE__ */ jsxs(Typography, { variant: "label-S", dir: "ltr", color: color || "secondary", children: [
            /* @__PURE__ */ jsx(ArrowIcon, { className: "inline h-5 w-5 rotate-90" }),
            /* @__PURE__ */ jsx("span", { children: data.TemperatureSummary.Past6HourRange.Maximum[unit].Value }),
            /* @__PURE__ */ jsx("span", { children: SYMBOLS[unit] })
          ] }) }),
          /* @__PURE__ */ jsx("div", { className: "flex items-center gap-px", children: /* @__PURE__ */ jsxs(Typography, { variant: "label-S", dir: "ltr", color: color || "secondary", children: [
            /* @__PURE__ */ jsx(ArrowIcon, { className: "inline h-5 w-5 -rotate-90" }),
            /* @__PURE__ */ jsx("span", { children: data.TemperatureSummary.Past6HourRange.Minimum[unit].Value }),
            /* @__PURE__ */ jsx("span", { children: SYMBOLS[unit] })
          ] }) })
        ] }),
        /* @__PURE__ */ jsx(Typography, { variant: "body-S", color: color || "secondary", className: "mt-1", children: data.WeatherText })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-end gap-2", children: [
      /* @__PURE__ */ jsx(
        ImageWithFallback,
        {
          src: `/@wbk/calendar/icons/forecast/${data.WeatherIcon}.png`,
          alt: data.WeatherText,
          className: "h-10 w-20 object-contain"
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: "flex gap-2 py-2", children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            shape: "text",
            className: "text-secondary p-0 opacity-50 aria-pressed:opacity-100",
            onClick: () => setUnit("Metric"),
            "aria-pressed": unit === "Metric",
            children: /* @__PURE__ */ jsx(Typography, { variant: "heading-XS", dir: "ltr", color, children: "\xB0C" })
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            shape: "text",
            className: "text-secondary p-0 opacity-50 aria-pressed:opacity-100",
            onClick: () => setUnit("Imperial"),
            "aria-pressed": unit === "Imperial",
            children: /* @__PURE__ */ jsx(Typography, { variant: "heading-XS", dir: "ltr", color, children: "\xB0F" })
          }
        )
      ] })
    ] })
  ] });
};
var Info_default = WeatherInfo;

// src/components/weather/Weather.tsx
import { Fragment, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var Weather = ({ className, type = "full", onClick, color = "secondary" }) => {
  const { locale } = useRouter();
  const { t } = useTranslation("calendar_common");
  const { city } = useConfig_default();
  const [unit, setUnit] = useState("Metric");
  const { data, isLoading } = useGetWeatherCondition({ lang: locale, city: city.slug });
  if (!data) {
    return null;
  }
  if (type === "mini") {
    return /* @__PURE__ */ jsx2(
      "div",
      {
        className: twMerge(
          "rounded-L p-M bg-secondary/5 relative space-y-4 overflow-hidden backdrop-blur-xl",
          className
        ),
        children: /* @__PURE__ */ jsx2(Info_default, { data, unit, setUnit, color })
      }
    );
  }
  if (type === "degree") {
    return /* @__PURE__ */ jsxs2(Fragment, { children: [
      /* @__PURE__ */ jsx2("span", { children: data ? data.TemperatureSummary.Past6HourRange.Minimum[unit].Value.toFixed(0) : "00" }),
      /* @__PURE__ */ jsxs2("span", { children: [
        " ",
        SYMBOLS[unit]
      ] })
    ] });
  }
  return isLoading ? /* @__PURE__ */ jsxs2("div", { className: twMerge("space-y-4", className), children: [
    /* @__PURE__ */ jsx2("div", { className: "bg-body-level-1 h-10 animate-pulse" }),
    /* @__PURE__ */ jsx2("div", { className: "bg-body-level-1 h-10 animate-pulse" }),
    /* @__PURE__ */ jsx2(Divider, {}),
    /* @__PURE__ */ jsx2("div", { className: "bg-body-level-1 h-10 animate-pulse" })
  ] }) : data ? /* @__PURE__ */ jsxs2(
    "div",
    {
      className: twMerge(
        "rounded-L p-M bg-secondary/5 relative space-y-4 overflow-hidden backdrop-blur-xl",
        className
      ),
      children: [
        /* @__PURE__ */ jsx2(Info_default, { data, unit, setUnit, color }),
        /* @__PURE__ */ jsx2(Divider, { className: "border-secondary/50 bg-primary" }),
        /* @__PURE__ */ jsx2(
          Button2,
          {
            as: Link,
            to: `/${locale}/weather`,
            shape: "text",
            className: "w-full justify-between p-0 text-center",
            onClick,
            arrow: true,
            arrowColor: color === "primary" ? "#404040" : "white",
            children: /* @__PURE__ */ jsx2(Typography2, { variant: "label-S", color, children: t("calendar_common:weather.view_events") })
          }
        )
      ]
    }
  ) : null;
};
var Weather_default = Weather;

// src/components/ui/extensions/ThemePopover.tsx
import { twMerge as twMerge2 } from "tailwind-merge";
import { Popover as BasePopover } from "@wbk/ui";
import { jsx as jsx3 } from "react/jsx-runtime";
var ThemePopover = (_a) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx3(
    BasePopover,
    __spreadProps(__spreadValues({}, props), {
      className: twMerge2(
        "bg-secondary/60 rounded-L border-secondary border backdrop-blur-xl",
        className
      )
    })
  );
};
var ThemePopover_default = ThemePopover;

// src/components/ui/Typography/LineClamp.tsx
import { Typography as Typography3 } from "@wbk/ui";
import { twMerge as twMerge3 } from "tailwind-merge";
import { jsx as jsx4 } from "react/jsx-runtime";
var LineClampTypography = (props) => {
  return /* @__PURE__ */ jsx4(Typography3, __spreadProps(__spreadValues({}, props), { className: twMerge3("leading-normal", props.className) }));
};
var LineClamp_default = LineClampTypography;

// src/components/events/card/ListItem.tsx
import { Button as Button3 } from "@wbk/ui";
import { Link as Link2, useRouter as useRouter2, useTranslation as useTranslation3 } from "@wbk/config";
import { twMerge as twMerge4 } from "tailwind-merge";
import { Heart } from "@wbk/svg";

// src/components/events/card/Price.tsx
import { useTranslation as useTranslation2 } from "@wbk/config";
import { Typography as Typography4 } from "@wbk/ui";
import { CurrencyPriceLabel } from "@wbk/currency";
import { jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var EventItemPrice = ({ event, className }) => {
  var _a;
  const { t } = useTranslation2("calendar_common");
  const price = event.price;
  return /* @__PURE__ */ jsxs3("div", { className, children: [
    typeof price === "number" && price > 0 && /* @__PURE__ */ jsx5(Typography4, { variant: "label-XS", strong: true, children: t("calendar_common:starts_from") }),
    /* @__PURE__ */ jsx5(Typography4, { as: "div", variant: "label-M", strong: true, children: /* @__PURE__ */ jsx5(CurrencyPriceLabel, { originalPrice: price, currency: (_a = event == null ? void 0 : event.currency) == null ? void 0 : _a.code, zeroAsFree: true }) })
  ] });
};
var Price_default = EventItemPrice;

// src/components/events/card/ListItem.tsx
import { jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var EventListItem = ({ event, className, onClick }) => {
  const { t } = useTranslation3("calendar_common");
  const { locale } = useRouter2();
  const { toggleFavorite, isFavorite } = useFavorites();
  const isFaved = isFavorite(event.slug);
  return /* @__PURE__ */ jsxs4(
    Button3,
    {
      "data-testid": `item_${event.slug}`,
      href: `/${locale}/${event.category.slug}/${event.slug}`,
      as: Link2,
      className: twMerge4("relative flex w-full justify-start gap-3 p-0 text-start", className),
      theme: "transparent",
      onClick,
      children: [
        /* @__PURE__ */ jsx6(
          ContentfulMedia_default,
          {
            className: "rounded-S h-full shrink-0 object-cover",
            media: event.image11,
            width: 120,
            height: 120,
            ratio: "1x1",
            fit: "thumb",
            placeholder: true
          }
        ),
        /* @__PURE__ */ jsxs4("div", { className: "grow space-y-0.5 py-2 [&>div:nth-child(1)]:text-xs [&>div:nth-child(3)]:text-sm", children: [
          /* @__PURE__ */ jsxs4("div", { className: "flex items-center justify-between gap-4", children: [
            /* @__PURE__ */ jsx6(LineClamp_default, { variant: "heading-XS", className: "line-clamp-2 max-w-xs", children: event.title }),
            /* @__PURE__ */ jsx6(
              Button3,
              {
                onClick: (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  toggleFavorite(event.slug, event.title);
                },
                className: "hover:bg-body/10 shrink-0 rounded-full p-2 ltr:mr-2 rtl:ml-2",
                shape: "text",
                "aria-label": isFaved ? t("calendar_common:favorites.remove") : t("calendar_common:favorites.add"),
                children: isFaved ? /* @__PURE__ */ jsx6(Heart, { className: "text-error stroke-body-light h-4 w-4 object-contain md:h-5 md:w-5" }) : /* @__PURE__ */ jsx6(Heart, { className: "stroke-body-dark text-body-light h-4 w-4 object-contain md:h-5 md:w-5" })
              }
            )
          ] }),
          /* @__PURE__ */ jsx6(Price_default, { event })
        ] })
      ]
    }
  );
};
var ListItem_default = EventListItem;

// src/components/ui/extensions/ThemeMenu.tsx
import { twMerge as twMerge5 } from "tailwind-merge";
import { Menu as BaseMenu } from "@wbk/ui";
import { jsx as jsx7 } from "react/jsx-runtime";
var ThemeMenu = (_a) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  var _a2;
  return /* @__PURE__ */ jsx7(
    BaseMenu,
    __spreadProps(__spreadValues({
      className
    }, props), {
      menu: {
        className: twMerge5(
          "bg-secondary/60 rounded-L backdrop-blur-xl [&_div]:bg-transparent [&_div>button]:border-none border-secondary border",
          (_a2 = props.menu) == null ? void 0 : _a2.className
        )
      }
    })
  );
};
var ThemeMenu_default = ThemeMenu;

// src/components/cards/IconItem.tsx
import { Button as Button4, Typography as Typography5 } from "@wbk/ui";
import { Link as Link3, useTranslation as useTranslation4 } from "@wbk/config";
import { ChevronIcon } from "@wbk/svg";
import { twMerge as twMerge6 } from "tailwind-merge";
import { jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var CardIconItem = ({ card, className, btnProps }) => {
  var _a;
  const { t } = useTranslation4("calendar_common");
  const href = (_a = card.button) == null ? void 0 : _a.href;
  const isSoon = !href || href === "#";
  return /* @__PURE__ */ jsxs5(
    Button4,
    __spreadProps(__spreadValues({
      theme: "secondary",
      as: Link3,
      href,
      className: twMerge6("space-y-S group h-full w-full p-4 text-start", className)
    }, btnProps), {
      children: [
        /* @__PURE__ */ jsxs5("div", { className: "gap-M flex items-center", children: [
          card.icon && /* @__PURE__ */ jsx8(
            ContentfulMedia_default,
            {
              media: card.icon,
              "aria-disabled": isSoon,
              className: "h-6 w-6 transition duration-500 aria-disabled:opacity-50 group-hover:aria-[disabled=false]:translate-x-4 group-focus:aria-[disabled=false]:translate-x-4 rtl:group-hover:aria-[disabled=false]:-translate-x-4 rtl:group-focus:aria-[disabled=false]:-translate-x-4"
            }
          ),
          isSoon && /* @__PURE__ */ jsx8(Typography5, { color: "tertiary", children: t("calendar_common:soon") })
        ] }),
        /* @__PURE__ */ jsxs5(
          "div",
          {
            "aria-disabled": isSoon,
            className: "flex w-full items-center justify-between transition duration-500 group-hover:aria-[disabled=false]:translate-x-4 group-focus:aria-[disabled=false]:translate-x-4 rtl:group-hover:aria-[disabled=false]:-translate-x-4 rtl:group-focus:aria-[disabled=false]:-translate-x-4",
            children: [
              /* @__PURE__ */ jsx8(Typography5, { variant: "body-L", className: "inline", children: card.title }),
              /* @__PURE__ */ jsx8(ChevronIcon, { className: "h-3 w-3 shrink-0 rtl:rotate-180" })
            ]
          }
        )
      ]
    })
  );
};
var IconItem_default = CardIconItem;

export {
  ThemePopover_default,
  LineClamp_default,
  Price_default,
  ListItem_default,
  ThemeMenu_default,
  Weather_default,
  IconItem_default
};
//# sourceMappingURL=chunk-RFVCAZY5.mjs.map